module.exports = __webpack_public_path__ + "static/media/icon_human.1d6a5d78.svg";